import React, { InputHTMLAttributes, forwardRef } from 'react';
import { BaseComponentProps } from '../../types';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>, BaseComponentProps {
  label?: string;
  labelPosition?: 'left' | 'right';
  indeterminate?: boolean;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, labelPosition = 'right', indeterminate = false, className = '', id, ...props }, ref) => {
    const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;

    const checkboxClasses = `w-4 h-4 rounded accent-primary border-primary text-primary focus:outline-none focus:ring-2 focus:ring-primary/20 dark:border-border-dark dark:bg-dark-background-tertiary transition-colors ${className}`;

    React.useEffect(() => {
      if (ref && typeof ref === 'object' && ref.current) {
        ref.current.indeterminate = indeterminate;
      }
    }, [indeterminate, ref]);

    const checkbox = <input ref={ref} type='checkbox' id={checkboxId} className={checkboxClasses} {...props} />;

    if (!label) {
      return checkbox;
    }

    return (
      <div className='flex items-center'>
        {labelPosition === 'left' && (
          <label htmlFor={checkboxId} className='mr-2 cursor-pointer text-sm text-gray-700 dark:text-dark-text-secondary'>
            {label}
          </label>
        )}
        {checkbox}
        {labelPosition === 'right' && (
          <label htmlFor={checkboxId} className='ml-2 cursor-pointer text-sm text-gray-700 dark:text-dark-text-secondary'>
            {label}
          </label>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
